module.exports = __webpack_public_path__ + "assets/ic-bitcoinist.c7a40c92.svg";